import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavigationLink, Separator } from './styled';

// TODO: refactor in functional component
class BreadcrumbLink extends Component {
  render() {
    const { linkId, name, url } = this.props;
    return (
      <div key={linkId}>
        <Separator>&gt;</Separator>
        <NavigationLink id={linkId} href={url} data-cy={`link-breadcrumb-${name}`}>
          {name}
        </NavigationLink>
      </div>
    );
  }
}

BreadcrumbLink.propTypes = {
  key: PropTypes.number,
  name: PropTypes.string,
  url: PropTypes.string,
};

export default BreadcrumbLink;
